import type { FollowupState } from '@contracts/procurement';

/**
 * Config DECLARATIVA del tablero: una sección por estado de seguimiento,
 * apiladas (nada mezclado). Agregar un estado (ej. 'rechazada' en fase 2) =
 * una entrada aquí; el board las pinta genéricamente.
 *
 * `columns` = keys del catálogo de PurchaseTable. Dentro de una sección la
 * columna "Estatus" sobra (la sección ES el estatus) y el SLA solo aplica a
 * 'nueva' (para el resto siempre sería "En tiempo" — ruido).
 */
export interface BoardSection {
  state: FollowupState;
  title: string;
  columns: string[];
  /** Punto de color del header (identidad de la sección). */
  accentDot: string;
  /** Las secciones de archivo (canceladas) arrancan colapsadas. */
  defaultOpen: boolean;
  emptyText: string;
}

export const BOARD_SECTIONS: BoardSection[] = [
  {
    state: 'nueva',
    title: 'Pendientes de autorizar',
    columns: ['name', 'company', 'requester', 'department', 'createdAt', 'ageDays', 'amount', 'urgency', 'slaState'],
    accentDot: 'bg-sky-500',
    defaultOpen: true,
    emptyText: 'Nada pendiente de autorizar. 🎉',
  },
  {
    state: 'autorizada',
    title: 'Autorizadas, pendientes de comprar',
    columns: ['name', 'company', 'requester', 'department', 'partner', 'createdAt', 'authorizedAt', 'amount', 'urgency'],
    accentDot: 'bg-emerald-500',
    defaultOpen: true,
    emptyText: 'Sin órdenes autorizadas por comprar.',
  },
  {
    state: 'en_compra',
    title: 'En compra',
    columns: ['name', 'company', 'requester', 'department', 'partner', 'authorizedAt', 'ageDays', 'amount'],
    accentDot: 'bg-amber-500',
    defaultOpen: true,
    emptyText: 'Sin órdenes en proceso de compra.',
  },
  {
    state: 'cerrada',
    title: 'Cerradas (compra completada)',
    columns: ['name', 'company', 'requester', 'department', 'partner', 'authorizedAt', 'amount'],
    accentDot: 'bg-emerald-700',
    defaultOpen: false,
    emptyText: 'Sin compras cerradas.',
  },
  {
    state: 'rechazada',
    title: 'Rechazadas',
    columns: ['name', 'company', 'requester', 'department', 'createdAt', 'amount', 'rejectionReason'],
    accentDot: 'bg-rose-600',
    defaultOpen: false,
    emptyText: 'Sin órdenes rechazadas.',
  },
  {
    state: 'cancelada',
    title: 'Canceladas',
    columns: ['name', 'company', 'requester', 'department', 'createdAt', 'amount'],
    accentDot: 'bg-red-400',
    defaultOpen: false,
    emptyText: 'Sin órdenes canceladas.',
  },
];
